/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    current: {
      description: 'When the current item is selected',
      type: 'state',
      values: [ true, false ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    isChild: {
      description: 'when the item is child of another child',
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true, hover: true, pressed: true },
      tokens: {
        groupBackgroundColor: '#e3e6e8',
        groupBorderColor: 'rgba(0, 0, 0, 0)',
        groupColor: '#676e73',
        itemBackgroundColor: '#e3e6e8',
        itemColor: '#676e73'
      }
    },
    {
      if: { focus: false, hover: true, pressed: false },
      tokens: {
        groupBackgroundColor: '#f4f4f7',
        groupColor: '#4b286d',
        itemBackgroundColor: '#f4f4f7',
        itemColor: '#4b286d'
      }
    },
    {
      if: { focus: true, pressed: false },
      tokens: {
        groupBorderColor: '#4b286d',
        groupBorderWidth: 1,
        groupColor: '#4b286d',
        itemBorderBottomColor: '#4b286d',
        itemBorderLeftColor: '#4b286d',
        itemBorderRightColor: '#4b286d',
        itemBorderTopColor: '#4b286d',
        itemColor: '#4b286d'
      }
    },
    {
      if: { expanded: true },
      tokens: { groupIcon: PaletteIconCaretUp }
    },
    {
      if: { current: true },
      tokens: {
        groupColor: '#4b286d',
        groupFontName: 'HNforTELUSSA',
        groupFontWeight: '700',
        itemColor: '#4b286d'
      }
    },
    {
      if: { current: true, pressed: true },
      tokens: {
        groupBackgroundColor: '#e3e6e8',
        groupBorderWidth: 1,
        groupColor: '#676e73',
        groupFontName: 'HNforTELUSSA',
        groupFontWeight: '700'
      }
    },
    {
      if: { isChild: true },
      tokens: {
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#e3e6e8',
        itemBorderLeftWidth: 4,
        itemBorderTopWidth: 1
      }
    },
    {
      if: { focus: true, isChild: true },
      tokens: {
        itemBorderBottomColor: '#4b286d',
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#4b286d',
        itemBorderRightColor: '#4b286d',
        itemBorderRightWidth: 1,
        itemBorderTopColor: '#4b286d',
        itemBorderTopWidth: 1
      }
    },
    {
      if: { hover: true, isChild: true },
      tokens: { itemBorderLeftColor: '#4b286d' }
    },
    {
      if: { current: true, isChild: true },
      tokens: { itemBorderLeftColor: '#4b286d' }
    },
    {
      if: { current: true, pressed: true },
      tokens: { itemColor: '#676e73' }
    },
    {
      if: { isChild: true, pressed: true },
      tokens: {
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#676e73',
        itemBorderTopWidth: 1
      }
    }
  ],
  tokens: {
    groupBackgroundColor: 'rgba(0, 0, 0, 0)',
    groupBorderColor: 'rgba(0, 0, 0, 0)',
    groupBorderRadius: 0,
    groupBorderWidth: 1,
    groupColor: '#414547',
    groupFontName: 'HNforTELUSSA',
    groupFontSize: 14,
    groupFontWeight: '400',
    groupHeight: 40,
    groupIcon: PaletteIconCaretDown,
    groupPaddingBottom: 12,
    groupPaddingLeft: 16,
    groupPaddingRight: 16,
    groupPaddingTop: 12,
    itemBackgroundColor: 'rgba(0, 0, 0, 0)',
    itemBorderBottomColor: 'rgba(0, 0, 0, 0)',
    itemBorderBottomWidth: 1,
    itemBorderLeftColor: 'rgba(0, 0, 0, 0)',
    itemBorderLeftWidth: 1,
    itemBorderRadius: 0,
    itemBorderRightColor: 'rgba(0, 0, 0, 0)',
    itemBorderRightWidth: 1,
    itemBorderTopColor: 'rgba(0, 0, 0, 0)',
    itemBorderTopWidth: 1,
    itemBorderWidth: 1,
    itemColor: '#414547',
    itemDisplay: false,
    itemFontName: 'HNforTELUSSA',
    itemFontSize: 14,
    itemFontWeight: '700',
    itemHeight: 40,
    itemOutline: 0,
    itemPaddingBottom: 12,
    itemPaddingLeft: 16,
    itemPaddingRight: 16,
    itemPaddingTop: 12,
    itemTextDecoration: 'none',
    lineHeight: 1.14285714286,
    minHeight: '100%',
    minWidth: '100%',
    shadow: {
      blur: 8,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: false,
      offsetX: 0,
      offsetY: 4,
      spread: 0
    }
  }
}
export default theme
